export function normalizeNotaEntityIds({
  productId = null,
  idMuestra = null,
  idPresupuestoA3Pedido = null,
} = {}) {
  const toNumOrNull = (v) =>
    v != null && v !== "null" && v !== "" ? Number(v) : null;

  return {
    productId: toNumOrNull(productId),
    idMuestra: toNumOrNull(idMuestra),
    idPresupuestoA3Pedido: toNumOrNull(idPresupuestoA3Pedido),
  };
}

export function canSaveNewNota({ nota, writer, responsible }) {
  return Boolean(String(nota ?? "").trim() && writer && responsible);
}

export function buildCreateNotaPayload({
  productId,
  idMuestra,
  idPresupuestoA3Pedido,
  nota,
  usuario,
  tipoNota,
  writer,
  responsible,
  status,
  targetDate,
  closingDate,
}) {
  const ids = normalizeNotaEntityIds({
    productId,
    idMuestra,
    idPresupuestoA3Pedido,
  });

  return {
    ...ids,
    nota,
    usuario: usuario || "Unknown",
    tipoNota,
    writer,
    responsible,
    status,
    targetDate,
    closingDate,
  };
}

export function buildEditNotaUpdatePayload(editNota, closingDate = new Date()) {
  if (!String(editNota?.nota ?? "").trim()) return null;

  return {
    nota: editNota.nota,
    tipoNota: editNota.tipoNota,
    writer: editNota.writer,
    responsible: editNota.responsible,
    status: editNota.status,
    targetDate: editNota.targetDate,
    closingDate: editNota.status === "Closed" ? closingDate : null,
  };
}

export function buildNotasDialogClosePayload({
  changed = false,
  productId,
  idMuestra,
  idPresupuestoA3Pedido,
  hasAttachments = false,
} = {}) {
  const payload = {
    changed,
    productId,
    idMuestra,
    idPresupuestoA3Pedido,
  };
  if (hasAttachments) payload.hasAttachments = true;
  return payload;
}

export function shouldLoadNotas({ open, productId, idMuestra, idPresupuestoA3Pedido }) {
  return Boolean(open && (productId || idMuestra || idPresupuestoA3Pedido));
}

export function adjuntoFileUrl(apiUrl, filePath) {
  const base = String(apiUrl ?? "").replace(/\/$/, "");
  const path = String(filePath ?? "").replace(/^\//, "");
  return `${base}/uploads/${path}`;
}

export function isImageAdjunto(mimeType) {
  return String(mimeType ?? "").startsWith("image/");
}
